module.exports = __webpack_public_path__ + "static/media/trash-2.7751dfe1.svg";